import moment from 'moment';
import { getFileViewUrl } from 'services/fileService';

export const handleViewFile = (url: string, features?: string) => {
  const fileViewUrl = getFileViewUrl(url);

  if (fileViewUrl) {
    window.open(fileViewUrl, '_blank', features);
  }
};

// Helper function to format date for input
export const formatDateForInput = (dateString: string | null | undefined) => {
  if (!dateString) return '';
  return moment(dateString).format('YYYY-MM-DD');
};

export function getFloorLabel(i: number): string {
  let suffix = 'th';
  if (!(i % 100 >= 11 && i % 100 <= 13)) {
    switch (i % 10) {
      case 1:
        suffix = 'st';
        break;
      case 2:
        suffix = 'nd';
        break;
      case 3:
        suffix = 'rd';
        break;
    }
  }
  return suffix;
}

export function formatFloorLabel(i: number): string {
  if (Number(i) === 0) return 'Ground Floor';
  if (Number(i) === -1) return 'Cellar';
  if (isNaN(i)) return i.toString();

  return `${i}${getFloorLabel(i)} floor`;
}

export const getApiErrorMessage = (
  error: any,
  fallback = 'Something went wrong',
) => {
  const payload = error?.response?.data || error;

  if (typeof payload === 'string') return payload;
  if (payload?.message) return payload.message;
  if (payload?.error) return payload.error;
  if (Array.isArray(payload?.errors)) return payload.errors.join(', ');
  if (error?.message) return error.message;

  return fallback;
};

export const paymentMethods = ['Cash', 'Bank', 'Cheque', 'Donated'];
